import { AccountTypeBadge } from "common/AccountTypeBadge";
import { FriendInteractionsButtons } from "common/FriendInteractionsButtons";
import { ProfileImg } from "common/ProfileImg";
import { Topo } from "common/styleguide/Topo";
import { j, nlToBr } from "lib/textUtils";
import React from "react";
import styles from "./UserBannerCard.scss";

export const UserBannerCard = ({ user, subscription, showDialog }) => {
  let badge;
  if (user.accountLevel > 0) {
    badge = <AccountTypeBadge accountLevel={user.accountLevel} size={14} />;
  } else if (subscription) {
    badge = "*"; // backend sends subscription if current user is admin, so this is implicitly admin-only
  }

  return (
    <Topo dark className={styles.UserBannerCard}>
      <div className={styles.profImgWrap}>
        <ProfileImg large user={user} className={styles.profImg} />
      </div>
      <div className={styles.profContent}>
        <h1>
          {user.name} {badge}
        </h1>
        {user.locality && (
          <div className={styles.location}>{j([user.locality, user.administrativeArea, user.countryCode])}</div>
        )}
        {user.description && <div className={styles.description}>{nlToBr(user.description)}</div>}
        <FriendInteractionsButtons user={user} />
      </div>
    </Topo>
  );
};
